import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-errors',
  template: `
    <div class="mo-errors" *ngIf="errors && errors.length > 0">
      <p *ngFor="let error of errors">
        <mat-icon>error_outline</mat-icon>
        <span>{{error}}</span>
      </p>
    </div>
  `,
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent {
  @Input() errors: string[] = [];
}
